/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Loader } from 'src/components/Loader';
import { ICrumbs } from 'src/components/profileComponents/Breadcrumbs';
import { translations } from 'src/constants/translations';
import { pathList } from 'src/containers/Profile/routeList';
import { useGetComplex } from 'src/hooks';
import { ComplexStatus } from 'src/components/profileComponents/ComplexStatus';
import { ComplexOverview } from 'src/components/profileComponents/EditComplex/components/ComplexOverview';
import { ComplexOverviewActions } from 'src/components/profileComponents/EditComplex/components/ComplexOverviewActions';
import { useGlobalGrid } from 'src/hooks/app/use-global-grid';
import { UsersPageWrapper } from 'src/components/profileComponents/Users/components/UsersPageWrapper';
import { ComplexImages } from './components/ComplexImages';

export const EditComplex = () => {
  const { id }: { id: string } = useParams();
  const { complex, fetchComplex } = useGetComplex(id);
  const { getGridsWidth } = useGlobalGrid();

  if (!complex) {
    return (
      <Box
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Loader />
      </Box>
    );
  }

  const {
    language,
    title,
  } = complex;

  const crumbs: ICrumbs[] = [
    {
      name: translations.complexesLink,
      url: `/profile/${pathList.complexes}`,
    },
    {
      name: `${translations.settings} ${title[language]}`,
    },
  ];

  return (
    <UsersPageWrapper
      crumbs={crumbs}
      title={(
        <Box display="flex">
          <Box display="flex" gap="10px" alignItems="center">
            <span>{`${translations.settings} ${title[language]}`}</span>
            <ComplexStatus complexStatus={complex.status} />
          </Box>
        </Box>
        )}
    >
      <Box display="flex" flexDirection="column" mt={5}>
        <Box display="flex" mb={4} alignItems="flex-start" flexWrap="nowrap" gap="16px" height="444px">
          <Box width={`${getGridsWidth(4)}px`}>
            <ComplexImages complex={complex} />
          </Box>
          <Box width={`${getGridsWidth(2)}px`} height="100%">
            <ComplexOverview
              complex={complex}
              fetchComplex={fetchComplex}
            />
          </Box>

        </Box>
        <Box mb="24px" mt="24px">
          {complex && (
            <ComplexOverviewActions complex={complex} />
          )}
        </Box>
      </Box>
    </UsersPageWrapper>
  );
};
